/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["nz-card[_ngcontent-%COMP%]{background-color:#fff;padding:5px;margin:10px;border-radius:4px;box-shadow:0 2px 4px rgba(0,0,0,.1)}"];
export { styles as styles };
